import {defineStore} from 'pinia';
import {ModuleFund} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import fundAPI from '@/apis/di/fundAPI';
const fundStore = new BaseDictionaryStore(fundAPI);
export const useFundStore = defineStore(ModuleFund, {
  state: () => ({
    ...fundStore.state,
    _config: {
      key: 'fund_id',
      code: 'fund_name',
      name: 'description',
      table: 'di_fund',
      quickFollow: 'active',
      moduleName: 'Quỹ tiền',
      defaultSort: 'fund_name',
    },
    moduleName: 'fund',
  }),
  actions: {...fundStore.action},
  getters: {
    ...fundStore.getters,
  },
});
